import { Alert, Slide, Snackbar } from "@mui/material";
import { useContext, useEffect } from "react";
import UIContext from "../../context/UIContext";

const SnackBar = () => {
  const { alertOpen, alertMessage, alertType, closeSnackBar } = useContext(UIContext);
  return (
    <Snackbar
      style={{ marginTop: '45px' }}
      open={alertOpen}
      autoHideDuration={3000}
      onClose={closeSnackBar}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      TransitionComponent={(props) => <Slide {...props} direction="right" />}
    >
      <Alert onClose={closeSnackBar} severity={alertType || 'success'} variant="filled" sx={{ width: '100%' }}>
        {alertMessage}
      </Alert>
    </Snackbar>
  );
};

export default SnackBar;
